import { Text } from 'native-base';

const MindGutContentPreview = () => {
  return <Text textAlign={'center'}>placeholder</Text>;
};

export default MindGutContentPreview;
